import _cloneDeep from "lodash.clonedeep";
import { searchDFS, createFile, createFolder } from "../utils";
import { FILE, FOLDER } from "./constants";

const reducer = (state, action) => {
  let newState = _cloneDeep(state);
  let node = null;
  let parent = null;
  if (action.payload && action.payload.id) {
    let foundNode = searchDFS({
      data: newState.currentStructure,
      cond: (item) => {
        return item.id === action.payload.id;
      },
    });
    node = foundNode.item;
    parent = node.parentNode;
  }

  switch (action.type) {
    case "SET_DATA":
      return {
        currentStructure: action.payload,
        lastAction: {
          type: action.type,
          payload: action.payload,
        },
      };

    case FILE.CREATE:
      const newFile = {
        id: action.payload.fileId,
        name: action.payload.name,
        url: action.payload.url ?? null,
        format: action.payload.format ?? "doc",
        content: action.payload.content ?? "",
      };
      node.files.push(createFile(newFile));
      return {
        currentStructure: newState.currentStructure,
        lastAction: {
          type: action.type,
          payload: newFile,
        },
      };

    case FOLDER.CREATE:
      node.files.push(createFolder({ name: action.payload.name }));
      return {
        currentStructure: newState.currentStructure,
        lastAction: {
          type: action.type,
          payload: action.payload,
        },
      };

    case FOLDER.EDIT:
    case FILE.EDIT:
      node.name = action.payload.name;
      return {
        currentStructure: newState.currentStructure,
        lastAction: {
          type: action.type,
          payload: action.payload,
        },
      };

    case FOLDER.DELETE:
    case FILE.DELETE:
      if (!parent || Array.isArray(parent)) {
        newState = newState.filter((file) => file.id !== action.payload.id);
        return newState;
      } else {
        parent.files = parent.files.filter(
          (file) => file.id !== action.payload.id
        );
      }
      return {
        currentStructure: newState.currentStructure,
        lastAction: {
          type: action.type,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export { reducer };
